import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import { LinearProgress, TextField } from "@mui/material";
import ButtonCompo from "../../component/ButtonCompo";
import InputField from "../../component/InputField";
import { useForm } from "react-hook-form";
import SelectField from "../../component/SelectField";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import dayjs from "dayjs";

function EditOnboardingEmployee() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm();
  const [salaryStructure, setSalaryStructure] = useState([]);
  const [copySalaryStructure, setCopySalaryStructure] = useState([]);
  const [salaryCalculationReload, setSalaryCalculationReload] = useState(false);
  const [allProjects, setAllProjects] = useState([]);
  const [managers, setManagers] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedGender, setSelcetdGender] = useState("")
  const [dob, setDob] = useState(dayjs());
  const [startShieft, setStartShieft] = useState();
  const [endShieft, setEndShieft] = useState();

  // salary calculation params
  const [basic, setBasic] = useState(0);
  const [ctc, setCtc] = useState(0);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeData !== null &&
      employeeData?.admin?.onBoardingAccess === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  // userid
  const {userId} = useParams()
  const [onboardedEmployeeData, setOnboardedEmployeeData] = useState()

  // fetch employee
  async function getEmployee() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/employee/${userId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setOnboardedEmployeeData(res.data?.data);
      // we are taking the salary structure from the employee data because there is already a salary structure with some values is stroed in employee document.
      setCopySalaryStructure(res.data?.data?.salaryStructure)
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Employee data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    // getSalaryStructure();
    getEmployee()
  }, [userId]);

  // set values to fields
  useEffect(()=>{
    setValue("fullName", onboardedEmployeeData?.fullName)
    setValue("profEmail", onboardedEmployeeData?.profEmail)
    setValue("role", onboardedEmployeeData?.role)
    setValue("designation", onboardedEmployeeData?.designation)
    setValue("phoneNumber", onboardedEmployeeData?.phoneNumber)
    setValue("probationPeriod", onboardedEmployeeData?.probationPeriod)
    setValue("department", onboardedEmployeeData?.department)
    setStartShieft(dayjs(onboardedEmployeeData?.startShieftTime, "HH:mm:ss"))
    setEndShieft(dayjs(onboardedEmployeeData?.endShieftTime, "HH:mm:ss"))
    setDob(dayjs(onboardedEmployeeData?.dob))
    setSelectedManager(`${onboardedEmployeeData?.manager}-${onboardedEmployeeData?.managerModel}`)
    setSelectedProject(onboardedEmployeeData?.project)
    setBasic(onboardedEmployeeData?.basic)
    setSelcetdGender(onboardedEmployeeData?.gender)
  },[onboardedEmployeeData])

  // check number fields
  useEffect(() => {
    if (ctc !== undefined && isNaN(ctc) && ctc?.length > 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Invalid number");
      setCtc(0);
    }
  }, [ctc]);

  // onboard employee
  async function employeeOnboard(data) {
    if (selectedManager?.length === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select a manager");
      return null;
    }
    if (dob?.$d === undefined) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select the date of birth");
      return null;
    }
    if (startShieft?.$d === undefined || endShieft?.$d === undefined) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select both shieft time");
      return null;
    }
    if (basic === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please enter salary details");
      return null;
    }
    /* hey developer, do you remember that I merge
    two value in a string to set as "value" attribute of <option> ?
    I hope you do. Now, I am splitting the string two extract 
    two values differently from that string. */
    const splitedManagerValue = selectedManager?.split("-");
    // we need to check whether the value splitted well or not
    if (!Array.isArray(splitedManagerValue)) {
      setOpen(true);
      setSuccess(false);
      setMessage("Something went wrong");
      return null;
    }
    // structuring object for backend
    let postData = {
      ...data,
      dob: dob?.$d,
      manager: splitedManagerValue[0],
      managerModel: splitedManagerValue[1],
      startShieftTime: new Date(startShieft?.$d).toLocaleTimeString(),
      endShieftTime: new Date(endShieft?.$d).toLocaleTimeString(),
      ctc: ctc,
      project: selectedProject,
      salaryStructure: copySalaryStructure,
      id: userId,
      companyId: employeeData?.companyId,
      basic: basic,
      gender: selectedGender
    };
    console.log(postData)
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/employee/onboarding/edit`,
        method: "post",
        data: postData,
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Employee onboarded successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  

  // update salary structure value
  const handleChangeSalary = (index, value) => {
    setCopySalaryStructure((prev) => {
      let newArr = [...prev];

      newArr[index] = { ...newArr[index], amount: value };

      // update the ctc when user update any value manually
      // let totalCtc = Number(basic); // Start with basic as the base for CTC calculation
      // newArr.forEach((f) => {
      //   if (f?.isEnable === false) return;

      //   // no calculation required, direct update with amount
      //   let newAmount = Number(f?.amount);

      //   console.log(newAmount);

      //   // check deduction
      //   if (f?.isDeduction) {
      //     totalCtc -= newAmount;
      //   } else {
      //     totalCtc += newAmount;
      //   }
      // });

      // // Set both the updated array and calculated CTC
      // setCtc(totalCtc);

      return newArr;
    });
  };

  //doing automatic calculations based on the salary structrure from API
  // useEffect(() => {
  //   let totalCtc = Number(basic); // Start with basic as the base for CTC calculation

  //   const updatedArr = copySalaryStructure.map((f) => {
  //     if (f?.isEnable === false) return f;

  //     let newAmount;
  //     if (f?.amountType === "amount") {
  //       // Use the flat amount directly
  //       newAmount = Number(f?.amount);
  //     } else {
  //       // Calculate percentage-based amount
  //       if(f?.amount > 0) {
  //         newAmount = Number(f?.amount)
  //       } else {
  //         newAmount = Math.floor(Number(basic) * (Number(f?.value) / 100));
  //       }
  //     }

  //     // Adjust totalCtc based on isDeduction flag
  //     if (f?.isDeduction) {
  //       totalCtc -= newAmount;
  //     } else {
  //       totalCtc += newAmount;
  //     }

  //     return { ...f, amount: newAmount };
  //   });

  //   // Update both the state variables only once after calculations
  //   setCopySalaryStructure(updatedArr);
  //   setCtc(totalCtc);
  // }, [basic]);

  //fetch all projects
  async function getProjects() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/projects`,
        method: "get",
        withCredentials: true,
      });
      // save the api data
      let rawData = res.data?.data;
      // go through every element
      let selectfieldData = rawData?.map((e) => {
        // structure the data as per selectfield data structure
        let newObj = {
          title: e,
          value: e,
        };
        return newObj;
      });
      setAllProjects(selectfieldData);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Project fetch failed");
    } finally {
      setLoading(false);
    }
  }

  //fetch all managers
  async function getManagers() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/all/managers`,
        method: "get",
        withCredentials: true,
      });
      //console.log(res.data?.data)
      let rawData = res.data?.data;
      let selectfieldData = [];
      rawData?.map((e) => {
        let newObj = {
          title:
            e?.managerRole === "CompanySuperadmin"
              ? `${e?.name}(Superadmin)`
              : e?.name, // add a extra reference for superadmin
          value: `${e?.mangerId}-${e?.managerRole}`, // we can't set object as "value" attribute of <option> tag but we can set string. I combine two data in a string.
        };
        selectfieldData.push(newObj);
      });
      setManagers(selectfieldData);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Managers fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // gender array
  const genderArray = [
    {
      title: "Male",
      value: "Male"
    },
    {
      title: "Female",
      value: "Female"
    },
    {
      title: "Others",
      value: "Others"
    },
  ]

  useEffect(() => {
    getProjects();
    getManagers();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center flex-col">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Onboard An Employee
          </h1>
          <div className="mt-5 w-full">
            <form className="mt-5" onSubmit={handleSubmit(employeeOnboard)}>
              <div className="w-full">
                <p className="mb-5 font-medium text-[17px]">
                  Personal & Job Details
                </p>
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                  <InputField
                    label="Name"
                    {...register("fullName", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    focused
                    error={errors?.name}
                  />
                  <TextField
                    label="Professional Email"
                    type="email"
                    {...register("profEmail", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    focused
                    error={errors?.email}
                  />
                  <InputField
                    label="Role"
                    {...register("role", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    focused
                    error={errors?.role}
                  />
                  <InputField
                    label="Designation"
                    {...register("designation", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    focused
                    error={errors?.designation}
                  />
                  <InputField
                    label="Phone Number"
                    {...register("phoneNumber", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      minLength: {
                        value: 10,
                        message:
                          "Phone number should not be less than 10 digits",
                      },
                      maxLength: {
                        value: 10,
                        message:
                          "Phone number should not be greater than 10 digits",
                      },
                      setValueAs: (value) => value.trim(),
                    })}
                    focused
                    error={errors?.phoneNumber}
                  />
                  <InputField
                    label="Probation Period(in months)"
                    {...register("probationPeriod", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    focused
                    error={errors?.probationPeriod}
                  />
                  <SelectField
                    label="Manager"
                    value={selectedManager}
                    setValue={(e) => setSelectedManager(e?.target?.value)}
                    valueArray={managers}
                  />
                  <SelectField
                    label="Project"
                    value={selectedProject}
                    setValue={(e) => setSelectedProject(e?.target?.value)}
                    valueArray={allProjects}
                  />
                  <SelectField
                    label="Gender"
                    value={selectedGender}
                    setValue={(e) => setSelcetdGender(e?.target?.value)}
                    valueArray={genderArray}
                  />
                  <InputField
                    label="Department"
                    {...register("department", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    focused
                    error={errors?.department}
                  />
                  <DatePicker
                    label="Date of birth"
                    onChange={(e) => setDob(e)}
                    value={dob}
                  />
                </div>
              </div>
              <div className="mt-5">
                {
                  <DemoContainer
                    components={["MobileTimePicker", "MobileTimePicker"]}
                  >
                    <div className="w-full">
                      <p className="text-[17px] font-medium">Shieft</p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10 mt-5">
                        <MobileTimePicker
                          label="From"
                          className="w-full"
                          onChange={setStartShieft}
                          value={startShieft}
                        />
                        <MobileTimePicker
                          label="To"
                          className="w-full"
                          onChange={setEndShieft}
                          value={endShieft}
                        />
                      </div>
                    </div>
                  </DemoContainer>
                }
              </div>
              <div className="mt-5 w-full">
                <p className="mb-5 font-medium text-[17px]">Salary Details</p>
                <div className="mt-5 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                  <InputField
                    label={"Basic"}
                    onChange={(e) => setBasic(e?.target?.value)}
                    value={basic}
                    focused
                  />
                  {copySalaryStructure?.map((e, i) => (
                    <InputField
                      label={e?.name}
                      value={e?.amount}
                      onChange={(e) => handleChangeSalary(i, e?.target?.value)}
                      key={i}
                    />
                  ))}
                  <InputField label={"CTC"} value={ctc} onChange={eve => setCtc(eve?.target?.value)} />
                </div>
              </div>
              <div className="mt-5 w-full flex justify-end items-end">
                <ButtonCompo variant={"contained"} type="submit">
                  Save
                </ButtonCompo>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditOnboardingEmployee;
